/**
 * Session-boundary teardown, called from `storeV2/store.ts` `reset()`.
 *
 * Replacing the provider store already gives the atoms their initial values back, but two
 * things live outside it and have to be cleared by hand: the handle registry (which pins
 * Files and in-flight requests aimed at the previous org) and the `atomFamily` cache of
 * per-item atoms.
 */
import { uploadItemFamily } from '../../atoms';
import { uploadRegistry } from '../../registry';

export const resetUploadQueue = () => {
  uploadRegistry.clear();
  [...uploadItemFamily.getParams()].forEach((id) => uploadItemFamily.remove(id));
};
